import { colors } from 'theme'

export const defaultThemeStyles = {
    'background-active': colors.white,
    'background': colors.cloud,
    text: colors.darkBlue
}
